/*
 * サブシステム名：マスタ管理
 * 機能名：定型コース登録
 * package版
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import date from '@/ddv2.library/date'
import google from '@/ddv2.library/utils/google'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
// import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import complements from '@/rahmen/complement'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import flowMixin from '@/mixins/flowMixins'

import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextArea = () => import('@/components/DdTextArea')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')

export default {
  name: 'TeikeiCourseEditForPackage',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdCheckbox,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSimpleTable,
    DdSubHeader,
    DdSwitch,
    DdTextArea,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdTimeBox,
    DdTimeBoxSwitching
  },
  data: () => ({
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {},

    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    baseYmd: date.getCurrentDate(),
    mapData: [],

    modeKengen: 2, // 0:読み取り専用,1:削除不可,2:フルアクセス
    modeOfEdit: 0,

    hinmeiSwitch: false,
    hatsuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiSwitch: false,
    chakuchiHmsSwitch: false,
    expandKeiyuchi: false,

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders

  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const self = this
      return self.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      const self = this
      return self.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const self = this
      return self.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const self = this
      return self.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const self = this
      return self.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const self = this
      return self.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= self.baseYmd && elem.tekiyoEndYmdDisp >= self.baseYmd
      })
    },
    // 品名マスタフィルター <-- ここまで
    // ----------------------------------------------------------------------------------------------------
    // 区分種別フィルタ
    // ----------------------------------------------------------------------------------------------------
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    calcUnchin () {
      let amount = 0

      let tanka = this.rec.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }

      if (this.rec.unchinKeisanKbn === '01') {
        let juchuSuryo = this.rec.juchuSuryo
        if (juchuSuryo === undefined || juchuSuryo === '' || juchuSuryo === null) { juchuSuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuSuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '02') {
        let juchuJuryo = this.rec.juchuJuryo
        if (juchuJuryo === undefined || juchuJuryo === '' || juchuJuryo === null) { juchuJuryo = '0' }

        amount = parseFloat(tanka, 10) * parseFloat(juchuJuryo, 10)
      } else if (this.rec.unchinKeisanKbn === '03') {
        amount = parseFloat(tanka, 10)
      }

      amount = this.calcFraction(amount)

      return amount
    },
    // 請求合計金額算出
    seikyuGokeiAmount () {
      let amount = 0

      let hiwayPrice = this.rec.hiwayPrice ?? '0'
      let unchinHokaKingaku = this.rec.unchinHokaKingaku ?? '0'
      let unchinHokaHikazei = this.rec.unchinHokaHikazei ?? '0'
      let jikanWarimashiKingaku = this.rec.jikanWarimashiKingaku ?? '0'
      let kyoriWarimashiKingaku = this.rec.kyoriWarimashiKingaku ?? '0'
      let warimashiSonotaKingaku = this.rec.warimashiSonotaKingaku ?? '0'

      if (this.rec.hiwayPrice === undefined || this.rec.hiwayPrice === '') { hiwayPrice = '0' }
      if (this.rec.unchinHokaKingaku === undefined || this.rec.unchinHokaKingaku === '') { unchinHokaKingaku = '0' }
      if (this.rec.unchinHokaHikazei === undefined || this.rec.unchinHokaHikazei === '') { unchinHokaHikazei = '0' }
      if (this.rec.jikanWarimashiKingaku === undefined || this.rec.jikanWarimashiKingaku === '') { jikanWarimashiKingaku = '0' }
      if (this.rec.kyoriWarimashiKingaku === undefined || this.rec.kyoriWarimashiKingaku === '') { kyoriWarimashiKingaku = '0' }
      if (this.rec.warimashiSonotaKingaku === undefined || this.rec.warimashiSonotaKingaku === '') { warimashiSonotaKingaku = '0' }

      const seikyuKazeiAmount = parseInt(this.calcUnchin, 10) +
                                parseInt(unchinHokaKingaku, 10) +
                                parseInt(jikanWarimashiKingaku, 10) +
                                parseInt(kyoriWarimashiKingaku, 10) +
                                parseInt(warimashiSonotaKingaku, 10)

      amount = seikyuKazeiAmount + parseInt(hiwayPrice, 10) + parseInt(unchinHokaHikazei, 10)

      return amount
    },
    // 支払運賃算出
    shiharaiGokeiAmount () {
      let amount = 0

      let yoshaUnchin = this.rec.yoshaUnchin ?? '0'
      let yoshaHiwayPrice = this.rec.yoshaHiwayPrice ?? '0'
      let yoshaUnchinHokaKingaku = this.rec.yoshaUnchinHokaKingaku ?? '0'
      let yoshaUnchinHokaHikazei = this.rec.yoshaUnchinHokaHikazei ?? '0'
      if (this.rec.yoshaUnchin === undefined || this.rec.yoshaUnchin === '') { yoshaUnchin = '0' }
      if (this.rec.yoshaHiwayPrice === undefined || this.rec.yoshaHiwayPrice === '') { yoshaHiwayPrice = '0' }
      if (this.rec.yoshaUnchinHokaKingaku === undefined || this.rec.yoshaUnchinHokaKingaku === '') { yoshaUnchinHokaKingaku = '0' }
      if (this.rec.yoshaUnchinHokaHikazei === undefined || this.rec.yoshaUnchinHokaHikazei === '') { yoshaUnchinHokaHikazei = '0' }

      const shiharaiKazeiAmount = parseInt(yoshaUnchin, 10) + parseInt(yoshaUnchinHokaKingaku, 10)

      amount = shiharaiKazeiAmount + parseInt(yoshaHiwayPrice, 10) + parseInt(yoshaUnchinHokaHikazei, 10)

      return amount
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return true
      }
      return false
    },
    isMapUsable () {
      if ((this.rec.hatsuchiId) ||
          (this.rec.keiyuchiId1) ||
          (this.rec.keiyuchiId2) ||
          (this.rec.keiyuchiId3) ||
          (this.rec.keiyuchiId4) ||
          (this.rec.keiyuchiId5) ||
          (this.rec.chakuchiId)) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        hatsuchiSwitch: this.hatsuchiSwitch,
        chakuchiSwitch: this.chakuchiSwitch,
        hinmeiSwitch: this.hinmeiSwitch,
        hatsuchiHmsSwitch: this.hatsuchiHmsSwitch,
        chakuchiHmsSwitch: this.chakuchiHmsSwitch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // データ抽出処理
    // ----------------------------------------------------------------------------------------------------
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        // /* eslint no-debugger: "warn" */
        // debugger

        this.HttpClient
          .get(`/api/v1/VwCD2mstd0460/Find?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              const x = data.payload

              if (x.hatsuchiHms) {
                x.hatsuchiHms = complements.parseTime(x.hatsuchiHms, false).substr(0, 5)
              }
              if (x.chakuchiHms) {
                x.chakuchiHms = complements.parseTime(x.chakuchiHms, false).substr(0, 5)
              }
              if (x.yoteiSagyoJikan !== null && x.yoteiSagyoJikan !== undefined) {
                x.yoteiSagyoJikan = filter.minToTimeFormatter(x.yoteiSagyoJikan)
              }
              if (x.warimashiTaishoJikan !== null && x.warimashiTaishoJikan !== undefined) {
                x.warimashiTaishoJikan = filter.minToTimeFormatter(x.warimashiTaishoJikan)
              }
              this.rec = x

              this.hinmeiSwitch = Boolean(!this.rec.mstHinmeiId && this.rec.hinmeiBiko)
              this.hatsuchiSwitch = Boolean(!this.rec.hatsuchiId && this.rec.hatsuchiBiko)
              this.hatsuchiHmsSwitch = Boolean(!this.rec.hatsuchiHms && this.rec.hatsuchiHmsBiko)
              this.chakuchiSwitch = Boolean(!this.rec.chakuchiId && this.rec.chakuchiBiko)
              this.chakuchiHmsSwitch = Boolean(!this.rec.chakuchiHms && this.rec.chakuchiHmsBiko)

              // クローン情報設定
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            }
          })
        resolve()
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('existsIdMethod')
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 戻るボタン押下
    // ----------------------------------------------------------------------------------------------------
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // キャンセルボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hinmeiSwitch = self.cloneData.hinmeiSwitch
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },

    // ----------------------------------------------------------------------------------------------------
    // 削除ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.convertToDBType()
            self.HttpClient.post('/api/v1/VwCD2mstd0460/Delete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            this.convertToDispType()
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },

    // ----------------------------------------------------------------------------------------------------
    // 複写ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onCopyButtonClick: function (e) {
      const self = this
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        self.Effects.loadStart()
        const x = self.rec
        x.id = -1
        x.MstTeikeiKihonJuchuId = -1
        x.MstTeikeiHinmokuJuchuId = -1
        x.MstTeikeiKihonSagyoId = -1
        x.MstTeikeiCourceSagyoId = -1
        x.MstTeikeiHinmokuSagyoId = -1
        x.MstTeikeiKihonHacchuId = -1
        x.MstTeikeiCourceHacchuId = -1
        x.MstTeikeiHinmokuHacchuId = -1
        x.teikeiCourseNo = null

        self.rec = x
        self.modeOfEdit = 0
        self.Effects.loadComplete()
      })
    },

    // ----------------------------------------------------------------------------------------------------
    // 保存ボタン押下
    // ----------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      this.rec.kihonUnchin = this.calcUnchin
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (data.isValid) {
              /*
              modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'info')

              self.id = data.payload.id
              self.rec = data.payload
              if (self.rec.hatsuchiHms) {
                self.rec.hatsuchiHms = complements.parseTime(self.rec.hatsuchiHms, false).substr(0, 5)
              }
              if (self.rec.chakuchiHms) {
                self.rec.chakuchiHms = complements.parseTime(self.rec.chakuchiHms, false).substr(0, 5)
              }
              self.convertToDispType()
              */
              self.id = data.payload.id
            } else {
              modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'error')
              self.Effects.loadComplete()
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.transition(1, { id: id }, self.initialize)
            // resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.convertToDispType()
            resolve()
          })
        }
      }
      self.register(opt)
    },
    registerPromise: function () {
      this.convertToDBType()
      const f = this.HttpClient.post('/api/v1/VwCD2mstd0460/Create', this.rec)
      return f
    },
    registerValidate: function () {
      return true
    },
    convertToDBType: function () {
      if (this.rec.yoteiSagyoJikan) {
        this.rec.yoteiSagyoJikan = filter.timeToMinFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan) {
        this.rec.warimashiTaishoJikan = filter.timeToMinFormatter(this.rec.warimashiTaishoJikan)
      }
    },
    convertToDispType: function () {
      if (this.rec.yoteiSagyoJikan !== null && this.rec.yoteiSagyoJikan !== undefined) {
        this.rec.yoteiSagyoJikan = filter.minToTimeFormatter(this.rec.yoteiSagyoJikan)
      }
      if (this.rec.warimashiTaishoJikan !== null && this.rec.warimashiTaishoJikan !== undefined) {
        this.rec.warimashiTaishoJikan = filter.minToTimeFormatter(this.rec.warimashiTaishoJikan)
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    onMapViewClick: function (target) {
      // 初期化
      this.mapData = []
      // 発地設定
      if ((this.rec.hatsuchiId) && this.rec.hatsuchiId !== '' && this.rec.hatsuchiId !== null) {
        const hatsuchi = {
          id: this.rec.hatsuchiId,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(hatsuchi)
        } else {
          this.mapData = [hatsuchi]
        }
      }
      // 経由地１ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId1) && this.rec.keiyuchiId1 !== '' && this.rec.keiyuchiId1 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId1,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地２ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId2) && this.rec.keiyuchiId2 !== '' && this.rec.keiyuchiId2 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId2,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地３ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId3) && this.rec.keiyuchiId3 !== '' && this.rec.keiyuchiId3 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId3,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地４ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId4) && this.rec.keiyuchiId4 !== '' && this.rec.keiyuchiId4 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId4,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 経由地５ ※日時は発地と同値を設定
      if ((this.rec.keiyuchiId5) && this.rec.keiyuchiId5 !== '' && this.rec.keiyuchiId5 !== null) {
        const keiyuchi = {
          id: this.rec.keiyuchiId5,
          ymdhms: this.baseYmd + (this.rec.hatsuchiHms !== undefined && this.rec.hatsuchiHms !== null && this.rec.hatsuchiHms !== '' ? this.rec.hatsuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(keiyuchi)
        } else {
          this.mapData = [keiyuchi]
        }
      }
      // 着地設定
      if ((this.rec.chakuchiId) && this.rec.chakuchiId !== '' && this.rec.chakuchiId !== null) {
        const chakuchi = {
          id: this.rec.chakuchiId,
          ymdhms: this.baseYmd + (this.rec.chakuchiHms !== undefined && this.rec.chakuchiHms !== null && this.rec.chakuchiHms !== '' ? this.rec.chakuchiHms : '00:00')
        }

        if (this.mapData.length > 0) {
          this.mapData.push(chakuchi)
        } else {
          this.mapData = [chakuchi]
        }
      }

      const url = 'https://www.google.com/maps/dir' + google.getAddressStrings(this.hacchakuchiList, this.mapData)
      window.open(url, '_blank')
    },

    // ----------------------------------------------------------------------------------------------------
    // 初期値設定
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      // this.baseYmd = date.getCurrentDate()
      // 入力項目
      this.rec.tantoEigyoshoId = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id

      // 入力制御
      this.modeKengen = 0
      this.modeOfEdit = 0
      this.hinmeiSwitch = false
      this.hatsuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiSwitch = false
      this.chakuchiHmsSwitch = false
    },

    // ----------------------------------------------------------------------------------------------------
    // 得意先設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 得意先IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeTokuisaki: function () {
      if (!this.rec.tokuisakiId) {
        this.rec.unchinHasuKeisanKbn = null
        return
      }
      console.log('changeTokuisakiId')
      this.rec.tokuisakiCd = indexeddb.getRecord(this.torihikisakiList, this.rec.tokuisakiId).torihikisakiCd
      this.getTokuisakiInfo(this.rec.tokuisakiId)
    },
    getTokuisakiInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCD2mstd0460/MstTokuisakiInfoFind?id=${this.rec.tokuisakiId}`)
          .then((data) => {
            this.recTokuisakiInfo = data.payload
            console.log('getTokuisakiInfo', this.recTokuisakiInfo)
            if (!this.rec.unchinKeisanKbn && this.recTokuisakiInfo.unchinKeisanKbn) {
              this.$set(this.rec, 'unchinKeisanKbn', this.recTokuisakiInfo.unchinKeisanKbn)
            }
            this.rec.unchinHasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn
            this.rec.warimashiJikanTanka = this.rec.warimashiJikanTanka ? this.rec.warimashiJikanTanka : this.recTokuisakiInfo.warimashiJikanTanka
            this.rec.warimashiKyoriTanka = this.rec.warimashiKyoriTanka ? this.rec.warimashiKyoriTanka : this.recTokuisakiInfo.warimashiKyoriTanka
          })
        resolve()
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 項目切替
    // ----------------------------------------------------------------------------------------------------
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    calcFraction: function (x) {
      if (!this.rec.unchinHasuKeisanKbn) {
      // 初期設定は四捨五入としておく
        x = Math.round(x)
      } else if (this.rec.unchinHasuKeisanKbn === '01') {
      // 切り捨て
        x = Math.floor(x)
      } else if (this.rec.unchinHasuKeisanKbn === '02') {
      // 四捨五入
        x = Math.round(x)
      } else if (this.rec.unchinHasuKeisanKbn === '03') {
      // 切り上げ
        x = Math.ceil(x)
      }
      return x
    }
  }
}
